module.exports = __webpack_public_path__ + "static/media/logo-io.fdebc2c7.svg";